exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".resourcesBackground{background-color:rgba(25,122,186,.1)}.main-product .toolBoxTitle{color:rgba(0,0,0,.8705882353);font-weight:500;font-size:30px}.main-product .toolBoxSubTitle{min-height:17px;font-size:14px}.main-product .toolStartButton{width:108px}.insurance-products .background-image-resources-class{background-size:cover;background-position:center;height:225px;width:100%;overflow:hidden;border-radius:10px;box-shadow:0px 3px 6px rgba(0,0,0,.16);max-width:1250px}.resource-center-panel{border-radius:4px}.resource-panel-title{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Resource Center/ResourceCenter.scss
// module id = 7484
// module chunks = 101